<template>
    <div class="col-sm-12 nopads">
        <div class="col-sm-12 pt-2">
            <h2>
                {{ $t('user.edit') }} </h2>
        </div>
        <div class="col-sm-12 form-data">

            <b-form-group
                    class="title"
                    label-for="firstName">
              <span class="span-title">
               {{ $t('user.first_name') }}
              </span>
                <b-form-input
                        id="name"
                        v-model="userUpdate.firstName"
                        type="text"
                        size="mb"
                />
            </b-form-group>

            <b-form-group
                    class="title"
                    label-for="lastName">
              <span class="span-title">
               {{ $t('user.last_name') }}
              </span>
                <b-form-input
                        id="name"
                        v-model="userUpdate.lastName"
                        type="text"
                        size="mb"
                />
            </b-form-group>

            <b-form-group
                    class="title"
                    label-for="email">
              <span class="span-title">
               {{ $t('user.email') }}
              </span>
                <b-form-input
                        id="name"
                        v-model="userUpdate.email"
                        type="text"
                        size="mb"
                />
            </b-form-group>

            <b-form-group
                    class="title"
                    label-for="admin">
                <b-form-checkbox
                        id="admin"
                        v-model="userUpdate.admin"
                        name="admin"
                >
                    {{ $t('user.admin') }}
                </b-form-checkbox>
            </b-form-group>

            <b-form-group
                    class="title"
                    label-for="active">
                <b-form-checkbox
                        id="active"
                        v-model="userUpdate.active"
                        name="active"
                >
                    {{ $t('user.active') }}
                </b-form-checkbox>
            </b-form-group>


            <b-form-group
                    class="title"
                    label-for="rights">
              <span class="span-title">
                     {{ $t('user.rights') }}
              </span>
            </b-form-group>
            <!-- New user rights -->
            <div
                    class="col-sm-12"
            >
                <!-- Existing user rights -->
                <b-row
                        v-for="right in userUpdate.rights"
                        :key="right.role.id+right.organization.id"
                        class="role">
                    <div class="col-sm-4 nopads pr-2">
                        {{ getRoleName(right.role.role) }}
                    </div>
                    <div class="col-sm-6 nopads ">
                        {{ right.organization.name }}
                    </div>
                    <div class="col-sm-2 nopads pl-2 text-right">
                        <b-button
                                variant="danger"
                                size="sm"
                                class="mr-1"
                                @click.stop="removeUserRight(right)"
                        >
                            <i class="fa fa-trash"/>
                        </b-button>
                    </div>
                </b-row>
                <!-- Placeholde for a new one -->
                <user-right-selector
                        :organizations="organizations"
                        :roles="roles"
                        ref="selector"
                        class="mt-3"
                        @addUserRight="addUserRight"/>
            </div>


            <div class="col-sm-12 button-container">
                <b-button
                        class="fair-button"
                        variant="danger"
                        :disabled="loading"
                        @click.stop="$emit('close')"
                >
                      <span>
                          {{ $t('common.cancel') }}
                      </span>
                </b-button>

                <b-button
                        class="fair-button"
                        variant="success"
                        :disabled="loading"
                        @click.stop="submitUser"
                >
                      <span>
                          {{ $t('common.save') }}
                      </span>
                </b-button>
            </div>
        </div>

        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </div>
</template>

<script>
    import FairApi from '../../modules/api'
    import {userHelper} from '../../mixins/UserMixin'
    import UserRightSelector from "./UserRightSelector"

    export default {
        name: 'user-editor',
        components: {UserRightSelector},
        mixins: [userHelper],
        props: {
            user: {
                type: Object,
                default: null

            }
        },
        created() {
            this.userUpdate = JSON.parse(JSON.stringify(this.user))
            this.fetchRoles()
            this.fetchOrganizations()
        },
        data: function () {
            return {
                loading: false,
                orgLoading: false,
                roleLoading: false,
                userUpdate: null,
                organizations: [],
                roles: [],
            }
        },
        methods: {
            fetchRoles: function () {
                this.loading = true
                this.roleLoading = true
                this.roles = []
                FairApi.get(FairApi.user("role"), this.handleRoles, this.fetchFail)
            },
            handleRoles: function (response) {
                this.roles = response || []
                this.roleLoading = false
                this.loading = this.roleLoading || this.orgLoading
            },
            fetchOrganizations: function () {
                this.loading = true
                this.orgLoading = true
                this.organizations = []
                FairApi.get(FairApi.organization(), this.handleOrg, this.fetchFail)
            },
            handleOrg: function (response) {
                this.organizations = response
                this.orgLoading = false
                this.loading = this.roleLoading || this.orgLoading
            },
            fetchFail: function () {
                this.$emit('alert', this.$t('common.fetch_failed'))
            },
            submitUser: function () {
                let json = this.setDefaultValues(this.userUpdate)
                if (json !== undefined) {
                    this.loading = true
                    FairApi.put(FairApi.user(), json, this.success, this.fail)
                }
            },
            setDefaultValues: function (userUpdate) {
                let user = JSON.parse(JSON.stringify(userUpdate))
                if (!user.firstName) {
                    this.$emit('alert', this.$t('user.invalid_firstName'))
                    return undefined
                }
                if (!user.lastName) {
                    this.$emit('alert', this.$t('user.invalid_lastName'))
                    return undefined
                }
                if (!user.email) {
                    this.$emit('alert', this.$t('user.invalid_email'))
                    return undefined
                }
                return user
            },
            success: function () {
                this.$emit('closeAndUpdate')
                this.loading = false
            },
            fail: function (response) {
                this.loading = false
                if (response.status === 409) {
                    this.$emit('alert', this.$t('user.duplicate_email'))
                } else {
                    this.$emit('alert', this.$t('common.alert_update_failed'))
                }
            },
            removeUserRight: function (userRight) {
                this.userUpdate.rights = this.userUpdate.rights.filter(function (value) {
                    return !(value.role.id === userRight.role.id && value.organization.id === userRight.organization.id)
                })
            },
            addUserRight: function (userRight) {
                if (userRight.organization && userRight.role) {
                    // Check if role - organization pair already exists and if not, add to user rights array
                    let existingRight = this.userUpdate.rights.find(item => item.organization.id === userRight.organization.id && item.role.id === userRight.role.id)
                    if (!existingRight) {
                        this.userUpdate.rights.push(userRight)
                        this.$nextTick(function () {
                            this.$refs.selector.reset()
                        })
                    }
                }
            }
        }
    }
</script>